import {Anchor, Group, Text} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import {ALL_YARDS} from '../dispatch/yards'
import {useEquipmentExceptions} from './use-equipment-checks'

export function EquipmentExceptionsLink({yardId}: {yardId: string | null}) {
    const {data} = useEquipmentExceptions(yardId)
    const count = data?.exceptions.length

    return (
        <Group gap={4} mb="xs">
            <Anchor
                size="sm"
                renderRoot={(props) => (
                    <Link
                        {...props}
                        to="/rental-assets/exceptions"
                        search={{yard: yardId ?? ALL_YARDS}}
                    />
                )}
            >
                Equipment exceptions
            </Anchor>
            {count != null ? (
                <Text size="sm" c={count > 0 ? 'orange' : 'dimmed'}>
                    ({count})
                </Text>
            ) : null}
        </Group>
    )
}
